import Choices from 'choices.js';
import { EventBus } from '../event-bus';

export default {
    name: 'member-tier-filter',
    props: ['default-filter', 'slug'],
    data() {
        return {
            filterBy: '',
            options: null,
            professionalServicesOptions: [
                { label: 'All Tiers', value: 'all', selected: this.filterBy === 'all' },
                { label: 'Influence', value: 'Influence', selected: this.filterBy === 'Influence' },
                { label: 'Access', value: 'Access', selected: this.filterBy === 'Access' },
            ],
            individualOptions: [
                { label: 'All Tiers', value: 'all', selected: this.filterBy === 'all' },
                { label: 'Contributor', value: 'Contributor', selected: this.filterBy === 'Contributor' },
                { label: 'Access', value: 'Access', selected: this.filterBy === 'Access' },
            ],
            filterSelect: '',
            memberTierFilter: '',

        };
    },
    computed: {
        showFilter() {
            if(this.slug === 'professional-services' || this.slug === 'individual') {
                return true;
            }
        },
    },
    mounted() {
        this.filterBy = 'all';
        this.filterSelect = this.$el.querySelector('select');

        this.options = this.professionalServicesOptions;

        this.memberTierFilter = new Choices(this.filterSelect, {
            searchEnabled: false,
            choices: this.options,
            itemSelectText: '',
            shouldSort: false,
        });

        return this.memberTierFilter;
    },
    watch: {
        filterBy(value) {
            this.setFilter(value);
        },
        slug: function(newVal) {
            this.setFilterOptions(newVal);
        }
    },
    methods: {
        setFilterOptions(val) {
            this.memberTierFilter.clearChoices();

            if (val === 'professional-services') {
                this.memberTierFilter.setValue(this.professionalServicesOptions);
            } else {
                this.memberTierFilter.setValue(this.individualOptions);
            }

            this.memberTierFilter.setChoiceByValue('all');
            this.filterBy = 'all';
        },
        setFilter(val) {
            EventBus.$emit('set-filter', val);
        }
    },
    template: `
        <div v-show="showFilter" class="member-tier-filter">
            <label class="member-tier-filter__label">Show</label>
            <select class="dropdown dropdown--icon-circle-chevron" v-model="filterBy">
            </select>
        </div>
    `,
};
